// extracted by mini-css-extract-plugin
export default {"warningContainer":"warningContainer__xc4zs"};